
import { Record } from 'immutable'
const Search = Record({
  name:null,
  todofuken:null,
  date:null,
  limit:null
});
export default Search;
